import React from 'react';
export function SocialProofBar() {
  return <section className="w-full bg-[#1a1400] py-12 px-4" data-id="element-257">
      <div className="max-w-5xl mx-auto" data-id="element-258">
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-6 mb-12 text-center" data-id="element-259">
          <div data-id="element-260">
            <div className="text-4xl sm:text-5xl font-black text-white" data-id="element-261">
              +500
            </div>
            <div className="text-[#FFD700] text-sm font-semibold mt-1" data-id="element-262">
              catequistas confían
            </div>
          </div>
          <div data-id="element-263">
            <div className="text-4xl sm:text-5xl font-black text-white" data-id="element-264">
              12+6
            </div>
            <div className="text-[#FFD700] text-sm font-semibold mt-1" data-id="element-265">
              Tomos + Bonos
            </div>
          </div>
          <div data-id="element-266">
            <div className="text-4xl sm:text-5xl font-black text-white" data-id="element-267">
              4.9/5
            </div>
            <div className="text-[#FFD700] text-sm font-semibold mt-1" data-id="element-268">
              calificación ⭐
            </div>
          </div>
          <div data-id="element-269">
            <div className="text-4xl sm:text-5xl font-black text-white" data-id="element-270">🇦🇷</div>
            <div className="text-[#FFD700] text-sm font-semibold mt-1" data-id="element-271">
              Todo el país
            </div>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4" data-id="element-272">
          <div className="flex items-start gap-3 bg-black/40 border border-[#FFD700]/20 rounded-xl p-4" data-id="element-273">
            <div className="w-10 h-10 rounded-full bg-[#FFD700]/20 flex items-center justify-center text-[#FFD700] font-black text-sm flex-shrink-0" data-id="element-274">
              MG
            </div>
            <div data-id="element-275">
              <div className="text-[#FFD700] text-xs mb-1" data-id="element-276">⭐⭐⭐⭐⭐</div>
              <p className="text-white text-sm font-medium" data-id="element-277">
                "Organicé todo el año de catequesis en una tarde. Nunca más
                llegué sin material a la parroquia. Las planificaciones me
                ahorran horas cada semana y los chicos lo notan."
              </p>
              <p className="text-gray-300 text-xs mt-1" data-id="element-278">
                — Marcela G., Córdoba | Catequista parroquial | Primaria
              </p>
            </div>
          </div>
          <div className="flex items-start gap-3 bg-black/40 border border-[#FFD700]/20 rounded-xl p-4" data-id="element-279">
            <div className="w-10 h-10 rounded-full bg-[#FFD700]/20 flex items-center justify-center text-[#FFD700] font-black text-sm flex-shrink-0" data-id="element-280">
              LP
            </div>
            <div data-id="element-281">
              <div className="text-[#FFD700] text-xs mb-1" data-id="element-282">⭐⭐⭐⭐⭐</div>
              <p className="text-white text-sm font-medium" data-id="element-283">
                "Los tomos están perfectamente pensados para la realidad del
                chico argentino. El de Secundaria 3° con Doctrina Social me
                cambió las clases. Vale cada peso."
              </p>
              <p className="text-gray-300 text-xs mt-1" data-id="element-284">
                — Laura P., Rosario | Docente de Religión | Secundaria
              </p>
            </div>
          </div>
          <div className="flex items-start gap-3 bg-black/40 border border-[#FFD700]/20 rounded-xl p-4" data-id="element-285">
            <div className="w-10 h-10 rounded-full bg-[#FFD700]/20 flex items-center justify-center text-[#FFD700] font-black text-sm flex-shrink-0" data-id="element-286">
              RM
            </div>
            <div data-id="element-287">
              <div className="text-[#FFD700] text-xs mb-1" data-id="element-288">⭐⭐⭐⭐⭐</div>
              <p className="text-white text-sm font-medium" data-id="element-289">
                "Nunca más llegué sin plan al aula. Mis clases de adolescentes
                por fin funcionan. El bono de manejo de aula fue el plus que me
                faltaba para sostener el grupo en los momentos difíciles."
              </p>
              <p className="text-gray-300 text-xs mt-1" data-id="element-290">
                — Roberto M., Buenos Aires | Docente de Catequesis | Secundaria
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}